import script from "./OutputInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./OutputInvoice.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__